(() => {
  angular
    .module('app.report')
    .factory('ExportService', ExportService);

  ExportService.$inject = ['$resource'];

  function ExportService($resource) {
    var exportService = $resource('/export/asyncdoc', {}, {
      'requestExport': {
        method: 'POST',
      }
    });

    exportService.exportDocument = (campaignId, campaignName, documentType, includeDelivery, engine) => {
      exportService.requestExport({
        'pid' : campaignId,
        'name' : campaignName,
        'document_type' : documentType,
        'include_traffic_quality': includeDelivery,
        'engine': engine
      }).$promise
        .then(
          function successCallback() {},
          function errorCallback() {
            Notification.onRequestFailed(uuid_stripped(), campaignId, campaignName);
          }
        );
    };

    return exportService;
  }
})();
